import styled from 'styled-components';

import { spacing, colors, borderRadius } from '../../../styles/theme';

import Text from '../Text';

export const Overlay = styled.div`
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);

  b {
    font-weight: bold;
  }

  &.fadeInOut-enter,
  &.fadeInOut-exit.fadeInOut-exit-active {
    opacity: 0;
  }

  &.fadeInOut-enter.fadeInOut-enter-active,
  &.fadeInOut-exit {
    opacity: 1;
  }

  transition: opacity 0.3s ease;
`;

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 160px;
  background-color: white;
  border-radius: ${borderRadius('base')};
  box-shadow: 0 3px 12px 0px rgba(0, 0, 0, 0.2);

  .fadeInOut-enter & {
    transform: scale(0.75);
  }

  .fadeInOut-enter.fadeInOut-enter-active &,
  .fadeInOut-exit & {
    transform: scale(1);
  }

  .fadeInOut-exit.fadeInOut-exit-active & {
    transform: scale(0.85);
  }

  transition: transform 0.25s ease;
`;

export const DialogTitle = styled(Text)`
  padding: ${spacing('2')} ${spacing('3')};
  color: ${colors('black.base')};
  font-size: 20px;
  font-weight: bold;
`;

export const DialogSection = styled.section`
  padding: ${spacing('1')} ${spacing('3')};
  flex: 1;
`;

export const DialogActions = styled.footer`
  padding: ${spacing('1')};
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
